import * as Yup from "yup";

import { UserKeys, validationMsgs } from "@sso/constant";

export const userFormSchemaValidation = Yup.object({
  [UserKeys.FIRST_NAME]: Yup.string()
    .required(validationMsgs.required)
    .min(2, validationMsgs.minlength(2))
    .max(20, validationMsgs.maxlength(20)),
  [UserKeys.LAST_NAME]: Yup.string()
    .required(validationMsgs.required)
    .min(2, validationMsgs.minlength(2))
    .max(20, validationMsgs.maxlength(20)),
  [UserKeys.USER_NAME]: Yup.string()
    .required(validationMsgs.required)
    .min(2, validationMsgs.minlength(2))
    .max(50, validationMsgs.maxlength(50)),
  [UserKeys.EMAIL]: Yup.string()
    .required(validationMsgs.required)
    .email(validationMsgs.email)
    .max(100, validationMsgs.maxlength(100)),
});
